// Popper
import * as Popper from "@popperjs/core"
window.Popper = Popper
